import React from 'react';
import {IonPage} from '@ionic/react';
import {useParams} from 'react-router';
import {useRecoilValue} from 'recoil';
import {singleNews} from '../state/news';
import useFetchSingleNews from '../hooks/useFetchSingleNews';
import formattedDate from '../utilis/formatDate';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UIImage from '../components/UICommon/UIImage';
import UIBackButton from '../components/UICommon/UIBackButton';
import UINoDataIndicator from '../components/UICommon/UINoDataIndicator';

const NewsPage: React.FC = () => {
  const {id} = useParams<any>();
  const {isLoading, isError} = useFetchSingleNews(id);
  const singleNewsData: any = useRecoilValue(singleNews);

  if (isLoading) {
    return <UILoadingIndicator/>;
  }

  if (isError) {
    return <UIErrorIndicator/>;
  }

  return (
    <IonPage className='p-6 flex flex-col overflow-y-auto bg-white'>
      <div className='h-16 w-fit sticky top-1 md:top-3 z-40 flex justify-end'>
        <UIBackButton href='/home'/>
      </div>
      {!singleNewsData ? <UINoDataIndicator/> : (
          <div className='flex flex-col md:flex-row-reverse md:pr-10'>
            <div className='font-Outfit text-navy-primary space-y-5 md:space-y-0 w-full'>
              <div className='flex flex-row justify-between md:pb-7 pt-12'>
                <div className='hidden md:block font-semibold text-22 w-4/5 leading-7'>{singleNewsData.title}</div>
                <div className='h-fit-content rounded-40 w-fit-content py-1 px-5 bg-purple-light text-purple-dark
        font-Outfit font-semibold text-sm'>{formattedDate(singleNewsData.created_at)}</div>
              </div>
              <div className='h-72 md:w-80 md:float-right md:pl-7 md:pb-7'>
                <UIImage url={singleNewsData.image} style='rounded-xl'/>
              </div>
              <div className='md:hidden font-semibold text-22 leading-7'>{singleNewsData.title}</div>
              <div className='font-normal text-base leading-5 text-justify'
                dangerouslySetInnerHTML={{__html: singleNewsData.content}}></div>
            </div>
          </div>)}
    </IonPage>
  );
};

export default NewsPage;
